export default __webpack_public_path__ + "static/media/Parent_Illustrations-14.26946916.svg";